import { UseMutationResult } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { createContext } from "react";

import { CreditBudgetResponse } from "@/types/response/CreditBudgetResponse";
import { DebitBudgetResponse } from "@/types/response/DebitBudgetResponse";
import { ValidationErrorResponse } from "@/types/response/ValidationResponse";

export interface UpdateMonthlyBudgetRequest {
  amount: number;
}

export interface UpdateMonthlyBudgetResponse {
  allocableBudget: number;
  allocableBudgetWithoutOverspend: number;
  allocatedBudget: number;
  clientId2: string;
  currentBudget: number;
  id: string;
  monthlyBudget: number;
}

export type ClientBudgetContextType = {
  isLoading: boolean;
  error: AxiosError | null;
  updateMonthlyBudget: UseMutationResult<
    AxiosResponse<UpdateMonthlyBudgetResponse>,
    AxiosError<ValidationErrorResponse>,
    { amount: number }
  >;
  updateAllowOverspend: UseMutationResult<
    AxiosResponse<void>,
    AxiosError<ValidationErrorResponse>,
    { allowOverspend: boolean }
  >;
  creditBudget: UseMutationResult<
    AxiosResponse<DebitBudgetResponse>,
    AxiosError<ValidationErrorResponse>,
    { amount: number; comments: string }
  >;
  debitBudget: UseMutationResult<
    AxiosResponse<CreditBudgetResponse>,
    AxiosError<ValidationErrorResponse>,
    { amount: number; comments: string }
  >;
};

export const ClientBudgetContext = createContext<
  ClientBudgetContextType | undefined
>(undefined);
